import { NotificationMessages } from '../types';

export const notificationES: NotificationMessages = {
    'app.notification.title': 'Centro de notificaciones',
    "app.notification.generate_file": "Estamos generando tu archivo. Una vez esté listo, recibirás una notificación para descargarlo.",
    'app.notification.download_program': 'Descargar detalles del programa',
};
